<template>
<!--  应用授权-->
  <div class="app-auth">
    <div class="type-title">
      <div class="icon"></div>
      <h3 class="type-text">浩邈产品</h3>
    </div>

    <a-row class="list-box" type="flex" justify="start">
      <a-col class="list-item" v-for="(item, index) of productList.list" :key="index">
        <p class="title">
          <span class="title-text">{{item.label}}</span>
          <img class="icon" :src="item.icon" alt="">
        </p>
        <p class="value">{{item.value}}</p>
        <p class=re-bind @click="changeAuth(item)">
          {{ item.change }}<img class="icon" src="../../assets/images/web/rightarrow.png" alt="">
        </p>
      </a-col>
    </a-row>

    <!--授权或取消授权的弹窗-->
    <a-modal
      :dialogStyle="{width: '480px'}"
      :visible="visible"
      @cancel="visible=false"
      @ok="visible = false"
      :destroyOnClose="true"
      :centered="true"
      :footer="null"
    >
      <p class="modal-title">取消授权</p>
      <div class="icon-contai">
        <div class="icon-box">
          <img class="logo" :src="appItem.icon" alt="">
        </div>
      </div>
      <h3 class="app-name">{{appItem.label}}</h3>
      <ul class="tip">
        <li>
            <p>本应用拥有以下权限：</p>
            <p>访问您的公开信息（昵称、头像）</p>
            <p>访问您的实名信息</p>
        </li>
        <li style="margin-top: 24px">
          <p>取消授权后，再次使用此应用需要重新授权。</p>
        </li>
      </ul>
      <div class="auth-btns">
        <a-button @click="cancelAuth">取消授权</a-button>
        <a-button @click="visible=false">关闭</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { visible, appItem, productList, getAuthList, changeAuth, cancelAuth } from '@/utils/setup/appAuth';

onBeforeMount(() => {
  getAuthList();
});
</script>

<style lang="scss" scoped>
.modal-title {
  margin-top: 48px;
  font-size: 20px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #00132E;
  line-height: 20px;
}
.icon-contai {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  .icon-box {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.app-name {
  margin-top: 16px;
  text-align: center;
  color: rgba(43, 54, 74, 1);
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
}
.tip {
  margin-top: 16px;
  font-size: 14px;
  line-height: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #868F9C;
}

</style>

<style lang="scss">
.ant-modal-body {
}
.auth-btns {
  margin-top: 32px;
  display: flex;
  .ant-btn {
    width: 196px;
    height: 44px;
    border: 1px solid rgba(233, 237, 243, 1);
    border-radius: 0;
    color: rgba(43, 54, 74, 1);
    font-family: PingFang SC;
    font-size: 14px;
  }
  .ant-btn:nth-child(1) {
    margin-right: 24px;
    color: rgb(250, 84, 94);
  }
}
</style>
